import React from 'react';
import { RadioButton, RadioButtonGroup, Checkbox } from 'material-ui';
import Icon from '../../tc-ui/icon';
import R from 'ramda';
import TypeControlledTextField from '../../tc-ui/type-controlled-textfield.jsx';
const isStayPaysNotEmpty = stayPays => R.any(stayPay => {
  return stayPay && stayPay.stayDays && stayPay.payDays;
}, stayPays);
const StayPay = ({
  defaultYes,
  staypayApplicable,
  stayPays,
  stayPayError,
  updateFieldValue,
}) => {
  return (
    <div style={{ marginTop: '8px' }}>
      <div style={{ display: defaultYes ? 'none' : 'block' }}>
        <label style={{ width: '50%' }}>
          Would you like to add a stay pay?
        </label>
        <RadioButtonGroup
          name="staypay"
          valueSelected={staypayApplicable === 'yes' || isStayPaysNotEmpty(stayPays) ? 'yes' : 'no'}
          style={{ display: 'inline-block', marginLeft: '12px', top: '10px', position: 'relative' }}
          onChange={(_, value) => {
            updateFieldValue('staypayApplicable', value);
            if (value === 'no') updateFieldValue('stayPays', [{}]);
          }}
        >
          <RadioButton label="Yes" value="yes" style={{ display: 'inline-block', width: '80px' }}/>
          <RadioButton label="No" value="no" style={{ display: 'inline-block', width: '50px' }}/>
        </RadioButtonGroup>
      </div>
      <div style={{ color: 'red', marginLeft: '2px', fontSize: '12px', verticalAlign: 'bottom' }}>{stayPayError}</div>
      {
        staypayApplicable === 'yes' || isStayPaysNotEmpty(stayPays) ? stayPays.map((stayPay, stayPayIndex) => (
          <div key={stayPayIndex}>
            <TypeControlledTextField
              controlledType="number"
              style={{ display: 'inline-block', width: '18%', zIndex: '0' }}
              hintStyle={{ fontSize: '12px' }}
              inputStyle={{ fontSize: '14px' }}
              floatingLabelShrinkStyle={{ color: 'rgba(0, 0, 0, 0.64)' }}
              floatingLabelText="# of Stay Days"
              hintText="# of Stay Days"
              value={stayPay.stayDays || ''}
              onChange={({ target: { value } }) => updateFieldValue('stayPays', R.update(stayPayIndex, R.merge(stayPay, { stayDays: value }), stayPays))}
            /><span style={{ color: 'red', marginLeft: '2px', fontSize: '24px', verticalAlign: 'bottom', width: '13px', display: 'inline-block' }}>{stayPay.stayDays ? '' : ' *'}</span>
            <TypeControlledTextField
              controlledType="number"
              style={{ display: 'inline-block', width: '18%', marginLeft: '3%', zIndex: '0' }}
              hintStyle={{ fontSize: '12px' }}
              inputStyle={{ fontSize: '14px' }}
              floatingLabelShrinkStyle={{ color: 'rgba(0, 0, 0, 0.64)' }}
              floatingLabelText="# of Pay Days"
              hintText="# of Pay Days"
              value={stayPay.payDays || ''}
              onChange={({ target: { value } }) => updateFieldValue('stayPays', R.update(stayPayIndex, R.merge(stayPay, { payDays: value }), stayPays))}
            /><span style={{ color: 'red', marginLeft: '2px', fontSize: '24px', verticalAlign: 'bottom', width: '13px', display: 'inline-block' }}>{stayPay.payDays ? '' : ' *'}</span>
            <TypeControlledTextField
              controlledType="number"
              style={{ display: 'inline-block', width: '25%', minWidth: '200px', marginLeft: '3%', zIndex: '0' }}
              hintStyle={{ fontSize: '12px' }}
              inputStyle={{ fontSize: '14px' }}
              floatingLabelShrinkStyle={{ color: 'rgba(0, 0, 0, 0.64)' }}
              floatingLabelText="Maximum FOC Nights"
              hintText="Maximum FOC Nights"
              value={stayPay.maxFOC || ''}
              onChange={({ target: { value } }) => updateFieldValue('stayPays', R.update(stayPayIndex, R.merge(stayPay, { maxFOC: value }), stayPays))}
            /><span style={{ color: 'red', marginLeft: '2px', fontSize: '24px', verticalAlign: 'bottom', width: '13px', display: 'inline-block' }}>{stayPay.maxFOC ? '' : ' *'}</span>
            <Icon
              className="tc-icon-close"
              style={{
                color: stayPays.length === 1 ? 'grey' : '#ff4081',
                cursor: stayPays.length === 1 ? 'normal' : 'pointer',
                marginLeft: '2%',
                top: '5px',
              }}
              onClick={stayPays.length === 1 ? undefined : () => updateFieldValue('stayPays', R.remove(stayPayIndex, 1, stayPays))}
            />
            <Icon
              className="tc-icon-add"
              style={{
                border: '2px solid green',
                borderRadius: '50%',
                cursor: 'pointer',
                marginLeft: '2%',
                top: '5px',
              }}
              onClick={() => updateFieldValue('stayPays', R.insert(stayPayIndex + 1, { stayDays: null, payDays: null }, stayPays))}
            />
          </div>
        )) : <div/>
      }
    </div>);
}

export default StayPay;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/staypay.jsx